//@ts-nocheck
export default {
  GROUP: "group",
  SPACING: "spacing",
  TEXT: "text",
  TABLE: "table",
  CHART: "chart",
};
